import { Component } from "@angular/core";
import { FieldType, Guid } from "@kre-form/core";
import { KreFormAntService } from "../tools/service";
@Component({
  selector: "krefield-radiogroup",
  template: `
    <ng-container *ngIf="formStatus !== 0; else other">
      <div class="control-design">
        <nz-radio-group
          [nzName]="'radiogroup-' + guid"
          [formControl]="formControl"
          [kreFormAttributes]="field"
          [class.is-invalid]="showError"
        >
          <ng-container *ngFor="let item of to.options">
            <label nz-radio [nzValue]="item.value" nzDisabled="true">{{
              item.label
            }}</label>
          </ng-container>
        </nz-radio-group>
      </div>
    </ng-container>

    <ng-template #other>
      <ng-container *ngIf="editor === true">
        <nz-radio-group
          [nzName]="'radiogroup-' + guid"
          [formControl]="formControl"
          [kreFormAttributes]="field"
          [class.is-invalid]="showError"
        >
          <ng-container *ngFor="let item of to.options">
            <ng-container *ngIf="to.type == 'button'">
              <label nz-radio-button [nzValue]="item.value">{{
                item.label
              }}</label>
            </ng-container>
            <ng-container
              *ngIf="
                to.type == null || to.type == undefined || to.type == 'default'
              "
            >
              <label nz-radio [nzValue]="item.value">{{ item.label }}</label>
            </ng-container>
          </ng-container>
        </nz-radio-group>
        <!-- <div class="tips">
          <i
            class="icon-bangzhu"
            [nzTooltipTitle]="tips"
            nzTooltipPlacement="top"
            nz-tooltip
            *ngIf="tips != ''"
          ></i>
        </div> -->
      </ng-container>

      <div class="fieldtext" *ngIf="editor === false">{{ textRadio }}</div>
    </ng-template>
  `,
})
export class KreFormFieldRadioGroup extends FieldType {
  guid: any = Guid.create()["value"];
}
